var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"switchButtonBox",style:(_vm.buttonBoxDynamic),on:{"click":_vm.toggle}},[_c('div',{staticClass:"switchButton",style:(_vm.buttonDynamic)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }